import { render, staticRenderFns } from "./LinkedCollateralFolder.vue?vue&type=template&id=04a08aa8&scoped=true&"
import script from "./LinkedCollateralFolder.vue?vue&type=script&lang=js&"
export * from "./LinkedCollateralFolder.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCollateralFolder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LinkedCollateralFolder.vue?vue&type=style&index=1&id=04a08aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a08aa8",
  null
  
)

export default component.exports